<obg-m-dialog-layout
	#dialog
	[dialogId]="dialogId"
	titleText="sga-verification-transaction.label"
	[hideFooter]="!isDesktop"
>
	<obg-m-sga-login-form-container
		[translationPrefix]="translationPrefix"
		(busy)="busy.emit({isBusy: $event})"
		(loginSubmit)="login($event)"
		submitBtnKey="sga-verification-transaction.verification.submit"
	>
		<p
			class="obg-m-sga-login-form-description login-title"
			[innerHtml]="'sga-set-password.validation-description' | translate"
		></p>
	</obg-m-sga-login-form-container>
</obg-m-dialog-layout>
